import { faAddressCard, faBell, faClock, faGaugeHigh, faGear, faPowerOff, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext, useEffect, useLayoutEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { UserContext } from '../../App';
import { AdminSchoolId, Camelcase, HideLoder, LogInSchoolID, LogInUserID, origin, RemoveAllCookies, ShowLoder } from '../../JS/Common';
import { ApiGetCall, ApiGetCallAuthKey, ApiPostCall, ApiPostCallAuthKey } from '../../JS/Connector';
import Cookies from 'js-cookie';
import { useDispatch } from 'react-redux';
import { setCsvUserID, setSchoolId, setSchoolnumber, setUserTimeZone } from '../../Store/Slices/authSlice';
import AlertsComp from '../AlertsComp';
import { store } from '../../Store/Store';
import { useSelector } from 'react-redux';
import { log } from '../../JS/Logger';
import { hasRoleAccess, RoleEnum, RoleKey } from '../../JS/RoleType';
import useConfig from '../../Hooks/useConfig';
import { Globalsearchbar } from '../Globalsearchbar';

export default function TopMenu({ setIsWrapperToggled, setAlerts }) {
    const reduxDispatch = useDispatch();
    const { show_external_faqs_link, external_faq_link, top_menu_panel_header, show_faq_link, adminCallNode } = useConfig();
    const pathname = window.location.pathname;
    const pathArray = pathname.split('/');
    const path = pathArray[1];
    const { UserData, setUserData } = useContext(UserContext);
    const { emailid: loggedinemailid, UserName: loggedinusername, MenuAccessFlag, copyaccesstype, role, copyrole } = UserData;
    const navigate = useNavigate();
    const firstLetter = loggedinusername.split(' ').map(name => name.charAt(0).toUpperCase()).join('');
    const [allTimeZone, setAllTimeZone] = useState([])
    const initState = store.getState();
    var userTimeZone = 'America/New_York'
    var SelectSchoolTimezoneVal = ''
    userTimeZone = initState?.authData?.UserTimeZone;
    SelectSchoolTimezoneVal = initState?.authData?.SelectedSchoolTimeZone;
    store.subscribe(() => {
        const state = store.getState();
        userTimeZone = state?.authData?.UserTimeZone;
        SelectSchoolTimezoneVal = state?.authData?.SelectedSchoolTimeZone;
    });
    const effectiveRole = copyrole || role || null;
    const ExcludeVar = hasRoleAccess(effectiveRole, RoleEnum.COMN_EXCLUDE_VAR);
    const mainSchlAdmin = hasRoleAccess(effectiveRole, RoleEnum.ONLY_SCHOOL_ADMIN);
    const [loading, setLoading] = useState(false);

    const adminSchoolId = useSelector((state) => state?.authData?.AdminSchoolId);
    const logInSchoolID = useSelector((state) => state?.authData?.SchoolId);
    const schoolValue = adminSchoolId ? adminSchoolId : logInSchoolID == 0 ? null : logInSchoolID

    useLayoutEffect(() => {
        ApiPostCall("/settings/configuration").then((result) => { log.error(result); });
    }, [])

    useEffect(() => {
        GetAllTimeZone();
    }, [userTimeZone]);
    async function GetAllTimeZone() {
        await ApiGetCallAuthKey("/settings/time-zones").then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setAllTimeZone(responseRs);
            }
        });

    }
    const FuncLogout = () => {
        RemoveAllCookies();
        const loadtesting = Cookies.get('isloadtesting');
        window.location.href = loadtesting == '1' ? '/loadtestinglogin' : '/k12logout';
    };
    async function BackToAdmin() {
        setLoading(true);
        var raw = JSON.stringify({
            loginUserId: LogInUserID,
            schoolAdminId: 0,
            flag: 2,
        });

        const result = await ApiPostCallAuthKey(`${adminCallNode}/technicians/set-school-login`, raw);
        if (!result) {
            alert("Something went wrong");
            setLoading(false);
            return;
        }

        setLoading(false);
        const responseRs = JSON.parse(result);
        if (responseRs.status == "success") {
            const sugData = responseRs.k12data;
            setUserData({ ...UserData, copyaccesstype: sugData?.temp_access_type });
            reduxDispatch(setCsvUserID(sugData?.id));
            reduxDispatch(setSchoolId(0));
            reduxDispatch(setSchoolnumber(''));
            window.location.href = '/school-tickets';
        } else {
            alert("Something went wrong");
        }
    }
    const DropdownItem = ({ icon, text, onClick }) => (
        <li>
            <a className="dropdown-item cursor-pointer" onClick={onClick}>
                <div className="d-flex align-items-center">
                    <FontAwesomeIcon icon={icon} className='me-3' />
                    {text}
                </div>
            </a>
        </li>
    );

    async function handleInputChange(e) {
        const value = e.target.value;
        var raw = JSON.stringify({
            userEmail: loggedinemailid,
            userTimeZoneId: value,
        });
        await ApiPostCall(`${adminCallNode}/settings/timezone/set`, raw).then((response) => {
            if (response == undefined || response == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(response);
                if (responseRs.status == "success") {
                    setAlerts(<AlertsComp show={true} variant="success" msg={`Timezone Updated Successfully`} />);
                    reduxDispatch(setUserTimeZone(responseRs?.user_time_zone || "America/New_York"));
                    setTimeout(function () {
                        setAlerts(<AlertsComp show={false} />)
                    }, 2500);
                } else if (responseRs.status == "error") {
                    reduxDispatch(setUserTimeZone(responseRs?.user_time_zone || "America/New_York"));
                }
                else {
                    setAlerts(<AlertsComp show={true} variant="danger" msg={response} />);
                    setTimeout(() => {
                        setAlerts(<AlertsComp show={false} />)
                    }, 2000);
                }
            }
        });
    }

    const timeZoneAccess = hasRoleAccess(effectiveRole, RoleEnum.ALL_ADMINS);
    const shouldShowTimezone = userTimeZone && (!timeZoneAccess || copyaccesstype);

    return (
        <>
            {loading ? <ShowLoder /> : <HideLoder />}
            <header className="top-header">
                <nav className="navbar navbar-expand">
                    <div className="mobile-toggle-icon fs-3" onClick={(e) => setIsWrapperToggled(prev => !prev)}>
                        <i className="bi bi-list"></i>
                    </div>
                    <div className="text-start w-100" style={{ color: '#151821' }}>
                        <h5 className='mb-0'>
                            <b>{hasRoleAccess(effectiveRole, RoleEnum.ONLY_VAR) ? "External Panel" : LogInSchoolID != 0 ?
                                UserData.schoolname : top_menu_panel_header}</b>
                        </h5>
                    </div>

                    {!copyaccesstype && hasRoleAccess(effectiveRole, RoleEnum.ALL_ADMINS) &&
                        <div className="col-7">
                            <Globalsearchbar />
                        </div>
                    }
                    <div className="top-navbar-right w-100 d-flex align-items-center justify-content-end">

                        {/* {timeZoneAccess && !copyaccesstype && (
                            <div className="col-md-3">
                                <select required name="timezone" onChange={handleInputChange}>
                                    {allTimeZone.map((item, i) => {
                                        return <option key={i} value={item.id} selected={userTimeZone == item.timezone}>{item?.timezone} - {item?.description}</option>
                                    })}
                                </select>
                            </div>
                        )} */}
                        <ul className="navbar-nav align-items-center pe-2">
                            {copyaccesstype && (
                                <li>
                                    <div className="dropdown-item cursor-pointer" onClick={BackToAdmin}>
                                        <FontAwesomeIcon icon={faUser} className="me-2" />
                                        <span className='text-decoration-underline'>Back to Admin Panel</span>
                                    </div>
                                </li>
                            )}
                            {shouldShowTimezone && (
                                <li>
                                    <div className="dropdown-item">
                                        <span>Timezone : {userTimeZone}</span>
                                    </div>
                                </li>
                            )}

                            {path != "create-ticket" && schoolValue && hasRoleAccess(effectiveRole, RoleEnum.CREATE_TICKET_TOP_MENU) && (
                                <li className="dropdown-item ms-3">
                                    <div className="d-flex align-items-center">
                                        <img
                                            src="/images/TicketIconforTopBar.svg"
                                            className="cursor-pointer"
                                            width={25}
                                            title="Create Ticket"
                                            loading="eager"
                                            onClick={() => navigate("/create-ticket", { state: { CreateTicketNext: 1, CreateTicketHeader: 1 } })} />
                                    </div>
                                </li>
                            )}
                            {ExcludeVar && show_faq_link ?
                                <Link className="dropdown-item ms-3" to="/faqs">
                                    <div className="d-flex align-items-center">
                                        <img src='/images/faqicon.svg' width={25} title='FAQs' loading="eager" />
                                    </div>
                                </Link> : null
                            }
                            {ExcludeVar && show_external_faqs_link && (
                                <a
                                    className="dropdown-item ms-3"
                                    href={external_faq_link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <div className="d-flex align-items-center">
                                        <img src="/images/faqicon.svg" width={25} title="FAQs" alt="FAQs" loading="eager" />
                                    </div>
                                </a>
                            )}

                            <li className="nav-item dropdown dropdown-user-setting">
                                <a className="nav-link dropdown-toggle dropdown-toggle-nocaret ps-4" href="#" data-bs-toggle="dropdown">
                                    <div className="user-setting d-flex align-items-center">
                                        <div className="profile-icon">
                                            <span>{firstLetter}</span>
                                        </div>
                                    </div>
                                </a>
                                <ul className="dropdown-menu dropdown-menu-end">
                                    <li>
                                        <a className="dropdown-item" href="#">
                                            <div className="d-flex align-items-center">
                                                <div className="profile-icon">
                                                    <span>{firstLetter}</span>
                                                </div>
                                                <div className="ms-3">
                                                    <h5 className="mb-0 dropdown-user-name">{loggedinusername && (Camelcase(loggedinusername))}</h5>
                                                    <small className="mb-0 dropdown-user-designation text-secondary" style={{ fontSize: '12px' }}>{loggedinemailid}</small>
                                                </div>
                                            </div>
                                        </a>
                                    </li>
                                    <hr className='my-1' />
                                    {mainSchlAdmin && (
                                        <DropdownItem icon={faGear} text="Settings" onClick={() => navigate('/setting')} />
                                    )}
                                    {mainSchlAdmin && (
                                        <DropdownItem icon={faAddressCard} text="Service Profile" onClick={() => navigate('/school-profile')} />
                                    )}
                                    {hasRoleAccess(effectiveRole, RoleEnum.BOTH_ADMIN) && (
                                        <DropdownItem icon={faBell} text="Notifications" onClick={() => navigate('/notifications')} />
                                    )}
                                    {timeZoneAccess && !copyaccesstype && (
                                        <div className="">
                                            <DropdownItem icon={faClock} text={<select required name="timezone" onChange={handleInputChange}>
                                                {allTimeZone.map((item, i) => {
                                                    return <option key={i} value={item.id} selected={userTimeZone == item.timezone}>{item?.timezone} - {item?.description}</option>
                                                })}
                                            </select>} />

                                        </div>
                                    )}
                                    <DropdownItem icon={faPowerOff} text="Sign Out" onClick={FuncLogout} />
                                </ul>
                            </li>
                        </ul>
                    </div>
                </nav >
            </header >
        </>
    )
}
